module.exports = __webpack_public_path__ + "static/media/chorthippus_dorsatus_004_APA.39f68738.png";